export * from './Slider';
export * from './Slider.interfaces';
